import React from "react";

const Banner = () => {
  return (
    <div
      className="container-fluid bg-black vh-50"
      style={{
        height: "300px",
        position: "absolute",
        zIndex: "-1",
        left: "0px",
        top: "0px",
      }}
    ></div>
  );
};

export default Banner;
